import { wceApi } from '@/api';
import { getCachedDesignEditor } from './design';

type GetDesignDeployDeployByMallNoResponse = {
  domain: string;
};

export const getDesignDeployDeployByMallNo = () => {
  return new Promise<GetDesignDeployDeployByMallNoResponse>((resolve, reject) => {
    getCachedDesignEditor(({ mallNo }) => {
      wceApi.get(`/design/deploy/deployByMallNo/${mallNo}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
};

type PageToHtml = {
  [pageId: string]: string;
};

type PostDesignDeployResponse = {
  domain: string;
};

export const publishPageContents = (
  pageToHtml: PageToHtml,
  cb: (url: string) => void
) => {
  getCachedDesignEditor(({ mallNo }) => {
    const contents = Object
      .keys(pageToHtml)
      .map((pageId) => {
        return {
          html: pageToHtml[pageId],
          pageId,
        }
      });

    wceApi.post<PostDesignDeployResponse>('/design/deploy', {
      contents,
      mallNo,
    })
      .then(({ data: { domain } }) => {
        const url = `https://${domain}`;
        cb(`<a href='${url}' target="deploy">${url}</a>`);
      });
  });
};

type PostDesignDeployPreviewResponse = {
  domain: string;
};

export const previewPageContents = (
  { htmls, pageId }: {
    htmls: PageToHtml,
    pageId: string;
  },
  cb: (url: string) => void
) => {
  getCachedDesignEditor(({ mallNo, readyshopConfig: { mallDns } }) => {
    const contents = Object
      .keys(htmls)
      .map((pageId) => ({
        html: htmls[pageId],
        pageId,
      }));

    wceApi.post<PostDesignDeployPreviewResponse>('/design/deploy/preview', {
      contents,
      mallNo,
      pageId,
    })
      .then(({ data: { domain } }) => {
        cb(`https://${mallDns}${domain}`);
      });
  });
};
